import React from 'react'
import { companyConfig } from '../../../config';

type Props = {
  /**
   * Use either this or children.
   */
  title?: string | string[];
  children?: any;
}

const defaultSeparator = " - ";
const defaultSuffix = companyConfig.company;

/**
 * Sets a document title on mount.
 * @author Johan Svensson
 */
export const DocumentTitle: React.FC<Props> = (props) => {
  React.useEffect(() => {
    var title = props.children;
    if (typeof title !== "string") {
      title = props.title
    }

    const isArray = Array.isArray(title)
    if (typeof title === "string" || isArray) {
      document.title = [...(isArray ? title : [title]), defaultSuffix]
        .filter(e => !!e).join(defaultSeparator);
    }
  }, [props.title, props.children])
  return null;
}